<div>
  <input
    #instructionStatusInput="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="ag-text-field-input"
    type="text"
    [(ngModel)]="currentValue"
    (click)="openMenu()"
    [ngClass]="currentValue ? 'input-background-active' : ''" />
    @if (!currentValue) {
      <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
    }
    @if (currentValue) {
      <span class="sdps-text-secondary delete-icon-padding" (click)="clearInstructionStatus($event)"
        ><img class="deleteIcon" [src]="deleteIcon"
      /></span>
    }

    <ng-template
      cdkConnectedOverlay
      (overlayOutsideClick)="toggleInstructionStatus(false)"
      (overlayKeydown)="toggleInstructionStatus(false)"
      [cdkConnectedOverlayOrigin]="instructionStatusInput"
      [cdkConnectedOverlayOpen]="isOpen">
      <div class="container">
        <div class="radio-btns">
          <ul>
            @for (instructionStatus of instructionStatusOptions; track instructionStatus) {
              <div class="instructionStatus-item">
                <input
                  type="radio"
                  [id]="instructionStatus"
                  name="instructionStatus"
                  [(ngModel)]="selectedValue"
                  [value]="instructionStatus" />
                  <label [for]="instructionStatus" [innerText]="instructionStatus"></label>
                </div>
              }
            </ul>
          </div>
          <div class="filter-actions">
            <button type="button" class="btn btn-success" (click)="applyInstructionStatus()">Apply</button>
            <a href="#" (click)="clearInstructionStatus($event)"> Clear </a>
          </div>
        </div>
      </ng-template>
    </div>
